(() => {
  // Match the cause's name, never its position: Contribe may reorder causes.
  const logos = new Map([
    ['grusbanden – fishing zealand', 'https://media.contribe.io/feature-list-icons/logo.png'],
    ['fyns laksefisk', 'https://media.contribe.io/feature-list-icons/fynslaks_logo_200.png'],
    ['danmarks center for vildlaks', 'https://media.contribe.io/feature-list-icons/laks.png'],
  ]);
  const observed = new WeakSet();
  const enhance = (root) => {
    const buttons = root.querySelectorAll('.contribe-selector-project-button');
    for (const button of buttons) {
      if (button.querySelector('img') || button.dataset.naLogoFailed) continue;
      const label = button.querySelector('.contribe-selector-project-selector-description, .contribe-list-name');
      const source = logos.get(label?.textContent.trim().toLocaleLowerCase('da'));
      if (!source) continue;
      const image = document.createElement('img');
      image.className = 'na-contribe-logo';
      image.src = source;
      image.alt = ''; // The adjacent cause name labels the existing button.
      image.width = 48;
      image.height = 48;
      image.addEventListener('error', () => {
        button.dataset.naLogoFailed = 'true';
        button.classList.remove('na-contribe-with-logo');
        image.remove();
      }, { once: true });
      button.classList.add('na-contribe-with-logo');
      button.prepend(image);
    }
    if (!root.querySelector('[data-na-contribe-logo-style]')) {
      const style = document.createElement('style');
      style.dataset.naContribeLogoStyle = '';
      style.textContent = `
        #contribe-selector .na-contribe-with-logo {
          flex-direction: row; justify-content: flex-start; gap: 12px;
          padding: 10px 12px; text-align: left;
        }
        #contribe-selector .na-contribe-with-logo > .contribe-icon { display: none !important; }
        #contribe-selector .na-contribe-with-logo > .contribe-selector-project-selector-description { display: block !important; }
        #contribe-selector .na-contribe-logo { width: 48px; height: 48px; object-fit: contain; flex-shrink: 0; }
      `;
      root.append(style);
    }
  };
  const scan = () => {
    document.querySelectorAll('contribe-plugin').forEach((host) => {
      const root = host.shadowRoot;
      if (!root || observed.has(root)) return;
      observed.add(root);
      enhance(root);
      new MutationObserver(() => enhance(root)).observe(root, { childList: true, subtree: true });
    });
  };
  // Wait for the vendor's custom element upgrade, then follow AJAX cart renders.
  customElements.whenDefined('contribe-plugin').then(() => {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  });
})();
